/**
 * selected.js
 * Written by: Alex Kasemir
 */

import userActions from '../../actions';

/**
 * Description of the selected reducer
 */
const selected = (state = null, action) => {
  switch (action.type) {
    case userActions.SELECT_USER:
      return action.id;
    case userActions.LOGOUT_SUCCESS:
      return null;
    default:
      return state;
  }
};

export default selected;
